import { useMediaQuery } from "@/hooks";
import {
  formatAlteracoes,
  rotuloAplicarSimulacao,
  SIMULACAO_APLICAR_CURTO,
  SIMULACAO_AVISO,
  SIMULACAO_AVISO_COM_ALTERACOES,
  SIMULACAO_AVISO_DIVERGENCIAS,
  SIMULACAO_COMPARAR_LABEL,
  SIMULACAO_SAIR_LABEL,
  SIMULACAO_TITULO,
} from "@/modules/recursos/simulacao";
import { CARGA_TRABALHO_MOBILE_QUERY } from "@/shared/components/gantt-carga/mobile";
import type { SimulacaoBannerProps, SimulacaoBannerViewModel } from "./types-simulacao-banner";

/**
 * Faixa do Modo Simulação (Figma 10880:56860).
 * Sem alterações: Sair da simulação (`onDescartar` → POST descarte); Aplicar fica desabilitado.
 * Com alterações: Sair da simulação (`onArquivar` → POST arquivamento), Comparar e Aplicar Simulação (N).
 * O "Ver alterações" da HU 2221 é o Comparar.
 */
export function useSimulacaoBanner({
  alteracoes,
  onAplicar,
  onComparar,
  onDescartar,
  onArquivar,
  hasDivergencias,
}: SimulacaoBannerProps): SimulacaoBannerViewModel {
  const semAlteracoes = alteracoes === 0;
  const mobile = useMediaQuery(CARGA_TRABALHO_MOBILE_QUERY);
  const rotuloAplicarCompleto = rotuloAplicarSimulacao(alteracoes);

  return {
    titulo: SIMULACAO_TITULO,
    contador: formatAlteracoes(alteracoes),
    semAlteracoes,
    aviso: semAlteracoes ? SIMULACAO_AVISO : SIMULACAO_AVISO_COM_ALTERACOES,
    avisoDivergencias: hasDivergencias ? SIMULACAO_AVISO_DIVERGENCIAS : null,
    mobile,
    rotuloAplicar: mobile ? SIMULACAO_APLICAR_CURTO : rotuloAplicarCompleto,
    rotuloAplicarCompleto,
    rotuloComparar: SIMULACAO_COMPARAR_LABEL,
    rotuloSair: SIMULACAO_SAIR_LABEL,
    aplicarDesabilitado: semAlteracoes || !onAplicar,
    mostrarAplicar: Boolean(onAplicar),
    mostrarSair: semAlteracoes && Boolean(onDescartar),
    mostrarSairComAlteracoes: !semAlteracoes && Boolean(onArquivar),
    mostrarComparar: !semAlteracoes && Boolean(onComparar),
    sair: onDescartar,
    sairComAlteracoes: onArquivar,
    comparar: onComparar,
    aplicar: onAplicar,
  };
}
